export default __webpack_public_path__ + "static/media/lush2.fd28a3b3.png";